
import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Context from "./context";
import SubmitForm from "./SubmitForm";
import Login from "./login";
import Home from "./home";
import Orders from "./orders";
import Orders2 from "./orders2";
import Items from "./items";
import Done from './done';
import CheckMy from './check_my';
import Miss_my from './missMy';

import PrintTable from './printTable';
import TableView from './TableView';
import Search from './search';

import Search2 from './search2';

import Mtab3ashipping from './Mtab3ashipping';

import Mtab3new from './Mtab3new';


import GetOrder from './GetOrder';
import Outs from './outOfStock';

import Mtab3aMiss from './Mtab3aMiss';
import Mtab3akadeb from './Mtab3akadeb';
import Mtab3amjel from './Mtab3amjel';

import Order from './orderById';
import Rejected from './rejected';
import Check2 from './check2';
import Edit from './edit';
import Print from './print';
import Error from './error';
import Contact from './Contact';
import './App.css'
import Miss from './Miss';
import Miss2 from './miss2';
import Support from './support';
import PrintNew from './printnew';
import host from './host';
import Cookies from "universal-cookie";
import axios from "axios";

import Mtab3aTajheez from './Mtab3aTajheez';




const cookies = new Cookies();
class App extends Component {
  constructor() {
    super();
    this.state = {

    }

  }
  componentDidMount() {

    console.log(  window.location.path );
    if ( window.location.pathname !== '/login' && window.location.pathname !== '/' ) {
      //  this.getUserData();
    }
    // this.getUserData();
  }

  getUserData = async () => {
    this.setState({ userDataLoading: true });
    const header = {
      "Content-Type": "application/json",
      Authorization: cookies.get("token")
    };

    try {
      const response = await axios.get(host + `users/auth/profile`, { headers: header });

      if (response.data.data.profile.isActive == true) {
        window.location.href = "/login";
      }

    } catch (error) {
      window.location.href = "/login";
      this.setState({ userDataLoading: false });
    }
  }
  render() {
    return (
      <BrowserRouter >
        <Context.Provider
          value={
            {
              value: this.state,
              actions: {
              }
            }
          }
        >

          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/From" component={SubmitForm} />
            <Route path="/getOrder" component={GetOrder} />
            <Route path="/outofstock" component={Outs} />
            <Route path="/login" component={Login} />
            <Route path="/Orders" component={Orders} />
            <Route path="/Orders2" component={Orders2} />
            <Route path="/Items" component={Items} />
            <Route path="/Done" component={Done} />
            <Route path="/edit" component={Edit} />

            {/* <Route path="/Print" component={PrintTable} /> */}
            <Route path="/TableView" component={TableView} />
            <Route path="/Contact" component={Contact} />
            <Route path="/search" component={Search2} />
            <Route path="/search2" component={Search2} />
            <Route path="/rejected" component={Rejected} />


            <Route path="/error" component={Error} />

            <Route path="/tesst" component={Error} />
            <Route path="/check_my" component={CheckMy} />
            <Route path="/miss_my" component={Miss_my} />
            <Route path="/check" component={Check2} />
            <Route path="/check2" component={Check2} />
            <Route path="/miss" component={Miss2} />
            <Route path="/miss2" component={Miss2} />
            <Route path="/order" component={Order} />
            <Route path="/Print2/:id" component={Print} />
            <Route path="/PrintNew/:id" component={PrintNew} />
            <Route path="/support" component={Support} />


            <Route path="/mtab3a-miss" component={Mtab3aMiss} />
            <Route path="/mtab3a-kadeb" component={Mtab3akadeb} />
            <Route path="/mtab3a-shipping" component={Mtab3ashipping} />
            <Route path="/mtab3a-tjheez" component={Mtab3aTajheez} />
            <Route path="/mtab3a-mjel" component={Mtab3amjel} />
            <Route path="/mtab3a-new" component={Mtab3new} />

          </Switch>

        </Context.Provider>
      </BrowserRouter>
    );
  }
}

export default App;




